export const DISCIPLINE_PRESETS = [
  "Longsword",
  "Single Rapier",
  "Rapier & Dagger",
  "Smallsword",
  "Sword & Buckler",
  "Sidesword",
  "Messer",
  "Saber / Military Saber",
  "Singlestick",
  "Dagger",
  "Polearm",
  "Women's Longsword",
  "Women's Single Rapier",
  "Women's Rapier & Dagger",
  "Women's Smallsword",
  "Beginners Longsword",
  "Beginners Rapier",
  "Open Cutting",
  "Armored Combat",
];
